/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import CouponGeneralDetail from "./CouponGeneralDetail";
import styles from "../../Pages/Coupon/coupon.module.css";

const CouponDetail = ({ setCouponData, couponData, types, setActiveTab, activeTab, error ,setError}) => {

  const sidebar = useRef()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebar.current && !sidebar.current.contains(event.target) && isSidebarOpen) {
          setIsSidebarOpen(false);
      }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  return (
    <div className={styles.couponDataWrapper}>
      <div className={styles.couponDataDetailBox}>
        {activeTab === "general" && 
          <CouponGeneralDetail 
            couponData={couponData}
            setCouponData={setCouponData}
            types={types}
            setError={setError}
            error={error}
          />
        }
      </div>

    </div>
  );
};

export default CouponDetail;
